import React, { useCallback } from "react";
// import classnames from "classnames";
import { Option } from "@shared/interfaces";

import { Label } from "../Label";

import "./index.scss";

export interface RadioGroup {
  name?: string;
  labelTitle?: string;
  labelClassName?: string;
  options: Option[];
  value?: Option | null;
  onChange?: (opt: Option | null) => void;
  disabled?: boolean;
}

const RadioGroup: React.FC<RadioGroup> = (props) => {
  const { labelTitle, labelClassName, options, value: selectedOption, onChange, ...inputProps } = props;

  const handleChange = useCallback(
    (e: React.ChangeEvent) => {
      const selectedVal = options.find((opt) => opt.value === (e.target as HTMLInputElement).value);
      onChange?.(selectedVal || null);
    },
    [options, onChange],
  );

  return (
    <div className="radio-group">
      {labelTitle ? <Label title={labelTitle} className={labelClassName} /> : null}
      {options.map((opt) => {
        return (
          <label className="radio-group-label" key={opt.value}>
            <input
              disabled={true}
              className="radio-group-input"
              type="radio"
              {...inputProps}
              value={opt.value}
              checked={selectedOption?.value === opt.value}
              onChange={handleChange}
            />
            <span className="radio-group-input-inner" />
            <span className="radio-group-input-label">{opt.label}</span>
          </label>
        );
      })}
    </div>
  );
};

export default RadioGroup;
